@if (raised) {
<button
  (click)="onClick()"
  [attr.data-action]="dataAction"
  [disabled]="isProcessing || disabled"
  color="primary"
  mat-flat-button
>
  <span [style.visibility]="styleVisibility(!isProcessing)" [translateParams]="translateParam" translate>
    {{buttonText}}
  </span>
  @if (isProcessing) {
  <mat-spinner class="processing-spinner" diameter="30" mode="indeterminate"></mat-spinner>
  }
</button>
} @if (!raised) {
<button (click)="onClick()" [attr.data-action]="dataAction" [disabled]="isProcessing || disabled" mat-stroked-button>
  <span [style.visibility]="styleVisibility(!isProcessing)" [translateParams]="translateParam" translate>
    {{buttonText}}
  </span>
  @if (isProcessing) {
  <mat-spinner class="processing-spinner" diameter="30" mode="indeterminate"></mat-spinner>
  }
</button>
}
